import { render, staticRenderFns } from "./AssociateToCase.vue?vue&type=template&id=784d11e0"
import script from "./AssociateToCase.vue?vue&type=script&lang=js"
export * from "./AssociateToCase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports